import { COLUMN_DATA_TYPE_ICONS } from "./ColumnsSelector";
import { Box } from "@mui/material";
import React from "react";

const DataTypeIcon = ({ type }) => {
  const Icon = COLUMN_DATA_TYPE_ICONS[type];
  return (
    <Box
      component={"span"}
      sx={{
        display: "inline-flex",
        alignItems: "center",
      }}
      aria-hidden
    >
      <Icon
        sx={{
          fontSize: 14,
          opacity: 0.8,
        }}
      />
    </Box>
  );
};
export default DataTypeIcon;
